/*
 * @Description:
 * @Date: 2024-12-09 19:46:44
 */
import { ContentTypeEnum } from './enums';

export const jsonConfig = {
  isParseToJson: true,
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
};
export const wwwConfig = {
  isParseToJson: false,
  headers: {
    'Content-Type': ContentTypeEnum.FORM_URLENCODED
  }
};
export const multipartConfig = {
  isParseToJson: false,
  headers: {
    'Content-Type': ContentTypeEnum.FORM_DATA
  }
};
